<template>
  <v-container class="about">
  	<v-row class="mb-5" align="center" justify="center">
    	<h1>{{ $t("Login.title") }}</h1><br>
    </v-row>
    <v-row align="center" justify="center">
    	<v-col class="pa-1" align="center" xs="12" sm="8" md="6">
		    <v-card max-width="600">
		      <v-card-text>
		        <v-form @submit.prevent="submit" ref="loginForm" lazy-validation>
		          	<!-- Username -->
	              <v-col cols="12">
	                <v-text-field
	                  prepend-icon="mdi-account"
						        v-model="form.username"
						        :label="$t('Login.username')"
						        required
					    		></v-text-field>
		    					<span style="color:red; float:left" v-if="errors.username">{{errors.username[0]}}</span>
	              </v-col>

	              <!-- Password -->
								<v-col cols="12">
									<v-text-field
										prepend-icon="mdi-lock"
										v-model="form.password"
										:append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
										:type="show ? 'text' : 'password'"
										:label="$t('Login.password')"
										hint="At least 8 characters"
										counter
										@click:append="show = !show"
									></v-text-field>
									<span style="color:red; float:left" v-if="errors.password">{{errors.password[0]}}</span>
								</v-col>

	              <v-col class="d-flex" cols="12" sm="6" xsm="12"></v-col>

		            <v-btn 
									x-large
									block
									type="submit"
									color="primary">
									{{ $t("Login.submit") }}
		        		</v-btn>
		          
		        </v-form>
		      </v-card-text>
		    </v-card>
			</v-col>
	  	<!-- Loading -->
	    <v-overlay :value="isLoading">
	      <v-progress-circular indeterminate size="64"></v-progress-circular>
	    </v-overlay>
    </v-row>
  </v-container>
</template>


<script>
	import User from "@/apis/User";

	import { mapActions,mapGetters } from 'vuex'

	export default{
		data(){
			return {
				form: {
					username: '',
					password : ''
				},
				errors: [],
				show: false,
				isLoading: false
			}
		},
		methods: {
			...mapActions({
        signIn: 'auth/signIn'
      }),

			async submit () {
				this.isLoading = true;

        await this.signIn(this.form)
        .then(res =>{
					this.$router.push({ name: 'Dashboard' })
        })
        .catch(error => {
					if(error.response.status === 422){
						this.errors = error.response.data.errors;
					}
				});

        this.isLoading=false;
      }
		}
	};
</script>